import { BaseModalComponent } from '../base/base-modal.component';
import { EMAIL_REGEX, PHONE_REGEX } from '../../../../../shared/regular-expressions/regex';
import { FormGenModel } from '../../../../../shared/models/form-gen.model';
import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { ModalController, NavParams } from '@ionic/angular';

export const CONTACT_LIST: FormGenModel[] = [
  { label: 'NAME', value: 'name' },
  { label: 'PHONE', value: 'phone' },
  { label: 'EMAIL', value: 'email' }
];

export const GENDER_LIST: FormGenModel[] = [
  { label: 'CONTACT_P_INFO', value: 'BILL' },
  { label: 'HEAD_OF_INSTITUTION', value: 'PAYOR' }
];

export function getContactFormGroup(contactForm?: FormGroup): FormGroup {
  return new FormGroup({
    purpose: new FormGroup({
      text: new FormControl(contactForm ? contactForm.value.purpose.text : 'BILL', Validators.required)
    }),
    name: new FormArray([
      new FormGroup({
        use: new FormControl('official'),
        prefix: new FormControl(''),
        family: new FormControl(''),
        given: new FormControl(''),
        suffix: new FormControl(''),
        text: new FormControl(contactForm ? contactForm.value.name : '')
      })
    ]),
    telecom: new FormArray([
      new FormGroup({
        system: new FormControl('EMAIL'),
        value: new FormControl(contactForm ? contactForm.value.email : ''),
        rank: new FormControl(1)
      }),
      new FormGroup({
        system: new FormControl('PHONE'),
        value: new FormControl(contactForm ? contactForm.value.phone : ''),
        rank: new FormControl(2)
      })
    ])
  });
}

@Component({
  selector: 'inc-contact',
  templateUrl: 'contact-info.component.html'
})
export class ContactInfoComponent extends BaseModalComponent {
  title = 'CONTACT_INFO';
  formGenList = CONTACT_LIST;
  formGenListType = GENDER_LIST;

  constructor(modalController: ModalController, private navParams: NavParams ) {
    super(modalController);

    this.reset(new FormGroup({
      purpose: new FormGroup({
        text: new FormControl('BILL', Validators.required)
      }),
      name: new FormControl('', Validators.required),
      email: new FormControl('', Validators.pattern(EMAIL_REGEX)),
      phone: new FormControl('', Validators.pattern(PHONE_REGEX))
    }));
  }

  save() {
    this.baseSave({ value: { contact: getContactFormGroup(this.form) } });
  }
}
